import { format, utcToZonedTime } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { useAuth } from 'context/AuthContext';

import MegaPhone from 'assets/img/megaphone-icon.svg';

import Avatar, { genConfig } from 'funifier-nice-avatar';

// import { getCompetitionLeaders } from 'services/leaderboard.service';
import Tippy from '@tippyjs/react';
import { ComportamentoHelpModal } from 'components/comportamento-help-modal';
import { Countdown } from 'components/countdown';
import { Colaboracao, FocoNoCliente, Inovacao, Lideranca, MandouBem, Resolutividade, Uau, Valeu } from 'components/icons';
import { SeloMoedasModal } from 'components/moeda-help-modal';
import { PontosHelpModal } from 'components/pontos-help-modal';
// import { Tutorial } from 'components/tutorial';
import { SeloHelpModal } from 'components/selo-help-modal';
import Button from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import { NotAllowed } from 'pages/NotAllowed';
import { BiInfoCircle, BiMenu, BiPlus } from 'react-icons/bi';
import { TbMailFast } from 'react-icons/tb';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  getGaleriaSecondByUser,
  getGroup,
  getKPIGaleriaReconhecimento,
  getKPIPointsOnline,
  getKPIPontosCultura,
  getMembrosEquipeGestor,
  getPlayerInfo,
  getResultadosByUser,
  getSelos,
  getUserGroup,
  verifyGame,
} from 'services/dashboard.service';
import { GroupDetailInterface, RankingKPI, UserGroupInterface, UsersNeedingApproval_Interface } from 'types/user';
import { TaskCycles } from './components/task-cycles';
import './styles.scss';

import { useMsal } from '@azure/msal-react';
// import Pascoa from 'assets/img/JJ_pascoa.png';
import Humanograma from 'components/Humanograma';
import Decoration from 'components/decoration';
// import { GameModal } from 'components/game-modal';
import { GroupDetailModal } from 'components/group-detail-modal';
import NewFeatures from 'components/new-features';
import Notification from 'components/notification';
import { PointItem } from 'components/point-item';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import ArticlePlaceholderSmall from 'components/ui/article-placeholder-small';
import { UserAvatar } from 'components/user-avatar';
import UserTutorial from 'components/user-tutorial';
import { useWebsocketNotification } from 'context/WebsocketNotificationContext';
import { MdContentPasteSearch } from 'react-icons/md';
import { getReconhecimentos } from 'services/achievement.service';
import { getBadges } from 'services/badges.service';
import { getBadgesUser, getChallenges } from 'services/challenges.service';
import { getLevelPlayer } from 'services/levels.service';
import { checkNotifications, clearNotifications, getAllNotifications } from 'services/notifications.service';
import { getPublicProfile, getUsersNeedingApproval } from 'services/profile.service';
import { getRegulation } from 'services/regulation.service';
import { getLevelDescription, getLevelTitle, GetVersion } from 'services/utils';
import { UserInfo } from 'types/user';
import { VERSION } from 'utils/constants';
import { Company } from './components/company';
import Quiz from 'components/quiz';
import imgBanner from 'assets/img/banner_sosfuncibb.jpg';
import CustomSelect from 'components/custom-select';
import Logo from 'components/logo';
// import { UserNeedingApprovalModal } from 'components/user-needing-approval-modal';
// import Decoration from 'components/decoration';
// import { GroupDetailModal } from 'components/group-detail-modal';
// import { PesquisaModal } from 'components/pesquisa-modal';
// import TutorialChallenges from 'components/tutorial-challenges';
// import Header from 'components/header';
// import { Tutorial } from 'components/tutorial';

const defautConfig = genConfig();

const dummyRankingKPI = { position: 0, total_positions: 0 };
const dummyKPI: any = {
  position: '---',
  uau: '---',
  mandou: '---',
  valeu: '---',
};

export function DashboardLegacy() {
  const {
    user,
    userInfo,
    refreshUser,
    signOut,
    currentCycle,
    isMSTeams,
    realCycle,
    cycleSelected,
    setCycleSelected,
    loadingInfo,
  } = useAuth();
  const { setMessage } = useWebsocketNotification();
  const [avatarConfig, setAvatarConfig] = useState(defautConfig);
  const [isGestor, setIsGestor] = useState(false);
  const [hasTeam, setHasTeam] = useState(false);
  const [showCatalog, setShowCatalog] = useState(false);
  const [groupInfo, setGroupInfo] = useState<any>();
  const [profile, setProfile] = useState<any>();
  const [lastUpdate, setLastUpdate] = useState<any>();
  const [usersNeedingApproval, setUsersNeedingApproval] = useState<UsersNeedingApproval_Interface[]>();
  const [rulesUrl, setRulesUrl] = useState<string>();
  const [showQuiz, setShowQuiz] = useState(false);

  const [load, setLoad] = useState(true);
  const { instance } = useMsal();

  const [selosBB, setSelosBB] = useState<any>();

  // const [tasks, setTasks] = useState<any>();
  // const [taskCycles, setTaskCycles] = useState<any>();
  // const [loadingTasks, setLoadingTasks] = useState(true);

  const [showTutorial, setShowTutorial] = useState(false);
  const [openTutorial, setOpenTutorial] = useState(false);
  const [closeFeatures, setCloseFeatures] = useState(false);

  const [sealList, setSealList] = useState<any[]>();
  const [loadingCulturaList, setLoadingCulturaList] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const { showModal } = useModal();

  const [destaqueCultura, setDestaqueCultura] = useState({
    foco: dummyKPI,
    colaboracao: dummyKPI,
    inovacao: dummyKPI,
    resolutividade: dummyKPI,
    lideranca: dummyKPI,
  });

  const [pontosCultura, setPontosCultura] = useState<{
    time: number;
    foco: number;
    colaboracao: number;
    inovacao: number;
    resolutividade: number;
    lideranca: number;
    total: number;
    geral: number;
    tasks: number;
    joga_junto: number;
    ranking_galeria: any;
  }>({
    time: 0,
    foco: 0,
    colaboracao: 0,
    inovacao: 0,
    resolutividade: 0,
    lideranca: 0,
    total: 0,
    geral: 0,
    tasks: 0,
    joga_junto: 0,
    ranking_galeria: undefined,
  });

  const [galeriaReconhecimento, setGaleriaReconhecimento] = useState<RankingKPI>(dummyRankingKPI);

  const optionsSelectCycle = useMemo(
    () =>
      realCycle?.map(x => {
        return {
          _id: x._id,
          title: x.title,
          version: GetVersion(x.date_start),
        };
      }),
    [realCycle],
  );

  const verifyVersionInit = useCallback(() => {
    if (cycleSelected && cycleSelected.version && cycleSelected.version !== 'v2') {
      navigate(`/${cycleSelected.version}/`);
    } else if (cycleSelected && !cycleSelected.version) {
      navigate('/');
    }
  }, [cycleSelected, navigate]);

  function handleNavMobile() {
    document.dispatchEvent(new CustomEvent('openNavMobile'));
  }

  function messageLevel() {
    return (
      <div>
        <p>A sua colocação é calculada sobre a quantidade total de pessoas do seu grupo.</p>
        <br />
        <p>
          Estarão na lista final da “Galeria do Reconhecimento”, somente os 30% melhores colocados do seu grupo (com
          arredondamento para cima).
        </p>
        <br />
        <p>A divulgação dos ganhadores será realizada em ordem alfabética. Apenas você poderá ver a sua colocação.</p>
      </div>
    );
  }

  const handleAvatarClick = useCallback(() => {
    showModal('avatar', { config: avatarConfig });
  }, [avatarConfig, showModal]);

  // const handlePascoaClick = () => {
  //   showModal('game-modal');
  // };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const result = await verifyGame('game_pascoa');

  //     if(!result) {
  //       showModal('game-modal');
  //     }
  //   };
  //   fetchData();
  // }, []);

  // function getTaskPoints(task: any) {
  //   const myPoints = task.team.find((item: any) => item._id === user?._id);
  //   return myPoints.points || 0;
  // }

  function getPositionLabel(kpi: RankingKPI) {
    try {
      return (
        <div className="p-1 text-center">
          <p>
            Você está na colocação <b>{kpi.position}</b> de <b>{groupInfo.total}</b> dentro do seu grupo.{' '}
            {!!lastUpdate
              ? `Ranking atualizado em: ${format(new Date(lastUpdate), 'd MMM yyyy, HH:mm', {
                  locale: ptBR,
                })}.`
              : ''}
          </p>
          <p>
            Estarão na lista final desta mecânica "Galeria do Reconhecimento", somente os 30% melhores colocados, com
            arredondamento para cima.
          </p>

          <p>A divulgação dos ganhadores será realizada por ordem alfabética.</p>
          <p>A sua posição nesta mecânica está visível somente a você.</p>
        </div>
      );
    } catch (e) {
      return `---`;
    }
  }

  function getPositionCulturaLabel(kpi: any) {
    try {
      return (
        <div className="p-1 text-center">
          <p>
            Você está na colocação <b>{kpi.posicao}</b> de <b>{groupInfo.total}</b> dentro do seu grupo.{' '}
            {!!lastUpdate
              ? `Ranking atualizado em: ${format(new Date(lastUpdate), 'd MMM yyyy, HH:mm', {
                  locale: ptBR,
                })}.`
              : ''}
          </p>

          <p>
            Estarão na lista final desta mecânica "Destaques da Cultura" 5% dos participantes dentro do seu grupo, com
            arredondamento para cima, que receberem mais pontos em cada Comportamento da Cultura.
          </p>

          <p>A divulgação dos ganhadores será realizada por ordem alfabética.</p>
          <p>A sua posição nesta mecânica está visível somente a você.</p>
        </div>
      );
    } catch (e) {
      return `---`;
    }
  }

  function getMoedas(data: any, moeda: string) {
    try {
      return data[moeda];
    } catch (e) {
      return '---';
    }
  }

  function getPontosPorCultura(data: any[], behavior: string) {
    const dummy = {
      posicao: '---',
      uau: '---',
      mandou: '---',
      valeu: '---',
    };
    const pontos = data.find((item: any) => item.behavior === behavior);
    if (!pontos) {
      return dummy;
    }
    return pontos;
  }

  useEffect(() => {
    try {
      const locationState: any = location.state;
      if (locationState && locationState.direction) {
        if (locationState.direction === 'back') {
          refreshUser();
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [location, refreshUser]);

  useEffect(() => {
    async function loadKPIComportamento() {
      try {
        const resultPointsOnline = await getKPIPointsOnline(user?._id, null, cycleSelected?._id);

        const _pontosCultura: any = {
          time: resultPointsOnline.time,
          foco: 0,
          colaboracao: 0,
          inovacao: 0,
          resolutividade: 0,
          lideranca: 0,
          total: resultPointsOnline.total || 0,
          geral: resultPointsOnline.geral || 0,
          tasks: resultPointsOnline.tasks || 0,
          joga_junto: resultPointsOnline.joga_junto || 0,
          ranking_galeria: !!resultPointsOnline.ranking_galeria ? resultPointsOnline.ranking_galeria : undefined,
        };

        resultPointsOnline.positions?.forEach((position: any) => {
          _pontosCultura[position.behavior] = position.total;
        });
        // console.log(_pontosCultura);
        setPontosCultura(_pontosCultura);

        // const kpiPontosCultura = await getKPIPontosCultura(user?._id);
        // setGaleriaReconhecimento({
        //   position: !!resultPointsOnline?.ranking_galeria?.position ? resultPointsOnline?.ranking_galeria?.position : 0,
        //   total: !!resultPointsOnline.geral ? resultPointsOnline.geral : 0,
        // });
        // setLastUpdate(kpiPontosCultura?.time || undefined);

        // if (!!kpiPontosCultura?.positions?.length) {
        //   const _destaqueCultura: any = {
        //     foco: { posicao: '---' },
        //     colaboracao: { posicao: '---' },
        //     inovacao: { posicao: '---' },
        //     resolutividade: { posicao: '---' },
        //     lideranca: { posicao: '---' },
        //   };

        //   kpiPontosCultura.positions.forEach((position: any) => {
        //     _destaqueCultura[position.behavior].posicao = position.position;
        //   });

        //   setDestaqueCultura(_destaqueCultura);
        // }
      } catch (e) {
        console.log(e);
      }
    }

    if (user?._id && cycleSelected?._id) {
      loadKPIComportamento();
    }
  }, [user?._id, cycleSelected?._id]);

  useEffect(() => {
    function updateAvatar() {
      if (user?.extra.avatar) {
        setAvatarConfig(user?.extra.avatar);
      }
    }

    function shouldShowTutorial() {
      if ((user?.extra.accept && !user?.extra.tutorial) || !localStorage.getItem('tutorial')) {
        setShowTutorial(true);
      }
    }

    async function loadlLevel() {
      try {
        if (!userInfo?.chave || !cycleSelected?._id) return;
        const data = await getLevelPlayer();
        const userProfile = await getPublicProfile(userInfo?.chave, cycleSelected?._id);

        setProfile({
          ...data,
          nivel: userProfile?.level || data.nivel,
          grupo: userProfile?.grupo || userInfo?.grupo?.nome,
          grupoTotal: userProfile?.grupo_total || userInfo?.grupo?.total,
        });
      } catch (e) {}
    }

    async function loadCulturalList() {
      if (!!user && !!user?._id) {
        let list = [];
        setLoadingCulturaList(true);
        const galeriaList = await getSelos();
        // const galeriaList = await getGaleriaSecondByUser(user?._id);
        // const culturalList = await getResultadosByUser(user?._id);

        list = [...galeriaList];

        setSealList(list);

        setLoadingCulturaList(false);
      }
    }

    if (!user || !cycleSelected) return;

    loadCulturalList();
    loadlLevel();
    updateAvatar();
    shouldShowTutorial();

    const returnURL = sessionStorage.getItem('return');

    if (returnURL) {
      sessionStorage.removeItem('return');
      navigate(returnURL);
    }
  }, [user, cycleSelected, navigate, showModal, userInfo]);

  useEffect(() => {
    async function loadTeam() {
      const catalog = await getGroup();

      if (
        userInfo &&
        (userInfo.tipo_ro === 'GERENCIAL' ||
          (typeof userInfo?.mad_dupla_tipo_ro === 'string' && userInfo?.mad_dupla_tipo_ro === 'GERENCIAL') ||
          userInfo.funcao_localizacao === 3001 ||
          userInfo.funcao_localizacao === 3002 ||
          userInfo.funcao_localizacao === 3003)
      ) {
        const data = await getMembrosEquipeGestor(userInfo._id);
        // const _usersNeedingApproval = await getUsersNeedingApproval();
        // setUsersNeedingApproval(_usersNeedingApproval);

        if (data?.result?.length) setHasTeam(true);
        setLoad(false);
      }

      if (catalog && catalog.grupo === 'CONSELHO DIRETOR E AUDITOR GERAL') {
        setShowCatalog(false);
      } else {
        setShowCatalog(true);
      }

      const regulation = await getRegulation();
      setRulesUrl(regulation?.url);

      setLoad(false);
    }

    if (!!userInfo && !!user && !!currentCycle) {
      setIsGestor(
        userInfo.tipo_ro === 'GERENCIAL' ||
          userInfo.funcao === 'DIRETOR' ||
          (typeof userInfo?.mad_dupla_tipo_ro === 'string' && userInfo?.mad_dupla_tipo_ro === 'GERENCIAL'),
      );
      if (userInfo.grupo) {
        setGroupInfo({
          ro: userInfo.ro,
          grupo_definido: userInfo.grupo_definido,
          ...userInfo.grupo,
        });
      }

      loadTeam();
    }
  }, [user, currentCycle, userInfo]);

  function handleLogout() {
    instance.logoutRedirect({
      onRedirectNavigate: () => false,
    });
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const updateAvatar = searchParams.get('avatar');
    const openQuiz = searchParams.get('quiz');
    const openTutorial = searchParams.get('tutorial');

    if (updateAvatar) {
      setTimeout(() => {
        handleAvatarClick();
      }, 1e2);

      searchParams.delete('avatar');
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }

    if (openQuiz) {
      setShowQuiz(true);

      searchParams.delete('quiz');
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }

    if (openTutorial) {
      setShowTutorial(true);
      setOpenTutorial(true);

      searchParams.delete('tutorial');
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (Array.isArray(usersNeedingApproval) && usersNeedingApproval.filter(x => !x.notificationBeenRead).length) {
      showModal('user-needing-approval-modal');
    }
  }, [showModal, usersNeedingApproval]);

  useEffect(() => {
    verifyVersionInit();
  }, [verifyVersionInit]);

  if (!user) return null;

  if (!user.extra.id) {
    return <NotAllowed />;
  }

  return (
    <>
      {/* <PesquisaModal /> */}
      <Outlet />

      <div className="flex flex-col pb-20 lg:pb-0 lg:flex-row mx-auto xl:container">
        <div className="p-6 lg:p-3 lg:w-1/3 flex flex-col items-center">
          <div className="w-full flex flex-row lg:flex-col lg:items-center justify-between my-2 lg:my-4 relative" tabIndex={1}>
            <div className="w-20 lg:w-72">
              <Logo />
            </div>
            {/* <div className="w-20 lg:w-36 absolute -bottom-4 right-12 cursor-pointer animate-wiggle" onClick={handlePascoaClick}>
              <img src={Pascoa} alt="Logo JogaJunto" className="relative" />
            </div> */}
            <div className="lg:hidden" onClick={() => handleNavMobile()}>
              <BiMenu size={32} />
            </div>
          </div>
          <div className="mt-8 lg:mt-5 text-left lg:text-center w-full">
            <h1 className="text-3xl text-white font-semibold" tabIndex={2} aria-label="Slogan: Juntos fazemos muito mais">
              Juntos fazemos <br />
              muito mais!
            </h1>

            <div
              className="relative border border-white w-[190px] mx-auto mt-5 pb-1 text-center uppercase"
              tabIndex={3}
              aria-label="Logo: Uma vida de oportunidades "
            >
              <span className="absolute -top-[8px] left-1/2 transform -translate-x-1/2 bg-[#032B4D] w-[110px] leading-none">
                Uma <b>vida</b> de
              </span>
              <p className="text-yellow leading-none text-xl mt-2">oportunidades</p>
            </div>

            {/* <p className="text-base lg:text-2xl font-light lg:font-normal leading-none">
                Jogue junto com a gente! <br />
                Seu reconhecimento <br /> vale muito.
              </p> */}
          </div>

          {Array.isArray(optionsSelectCycle) && !!optionsSelectCycle.length && (
            <div className="w-full lg:w-[206px] mt-10">
              <CustomSelect
                disabled={loadingInfo}
                value={{
                  label: cycleSelected?.title,
                  value: cycleSelected?._id,
                }}
                placeholder="Clique para selecionar o ciclo"
                options={optionsSelectCycle.map((item: any) => {
                  return {
                    label: item.title,
                    value: item._id,
                  };
                })}
                onChange={(e: any) => {
                  const selected = optionsSelectCycle.find(x => x._id === e.value);
                  setCycleSelected(selected);

                  console.log(selected?.version);

                  if (!!selected?.version && selected?.version !== 'v2') {
                    navigate(`/${selected.version}/`);
                  } else {
                    navigate('/');
                  }
                }}
              />
            </div>
          )}

          {load && (
            <div className="space-y-3 w-full hidden lg:flex flex-col items-center mt-10">
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
              <ArticlePlaceholderSmall />
            </div>
          )}

          {!load && (
            <div data-step="6" className="hidden lg:flex flex-col space-y-5 mt-10">
              {/* {user?.extra?.rede && (
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-2xl font-normal leading-none hover:text-yellow focus:text-yellow active:text-yellow text-yellow flex items-center justify-center space-x-2 mb-3"
                >
                  <MdContentPasteSearch className="text-[2.5rem]" />{' '}
                  <span className="text-2xl font-normal leading-none">
                    Quiz Regras <br /> do Programa
                  </span>
                </button>
              )} */}

              {/* <a
                href="https://forms.office.com.mcas.ms/pages/responsepage.aspx?id=BykM6tI4gUGHULCxkLYEQ86IL6aO8Y9IoaMZHcLVA5dUQlVaVUY4SFNIUUdaMU1HQ08yWUxWRkRFUS4u"
                target="_blank"
                rel="noreferrer"
                className="text-2xl font-normal leading-none hover:text-yellow focus:text-yellow active:text-yellow text-yellow flex items-center justify-center space-x-2 mb-3"
              >
                <MdContentPasteSearch className="text-[2.5rem]" />
                <span className="text-2xl font-normal leading-none">
                  Avalie o #JogaJuntoBB
                </span>
              </a> */}

              <Link
                to="/destaques"
                aria-label="Destaques do Joga junto"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline shadow-xl font-bold px-4"
                children={<span className="p-2 w-full uppercase">DESTAQUES</span>}
              />

              {showCatalog && (
                <Link
                  to={`${user?.extra?.rede ? '/loja' : '/catalogo-de-experiencias'}`}
                  aria-label="Catálogo de experiências Livelo"
                  className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  children={<span className="p-2 w-full uppercase ">PONTOS LIVELO</span>}
                />
              )}

              {/* <Link */}
              {/* <Link
                to="/destaques-cultura"
                children={
                  <Button
                    color="primary"
                    className="p-2 w-full uppercase rounded-md"
                  >
                    DESTAQUES DA CULTURA BB
                  </Button>
                }
              /> */}

              {/* <Link
              to="/destaques-cultura"
              children={
                <Button color="primary" className="p-2 w-full uppercase rounded-md">
                  Destaques da Cultura BB
                </Button>
              }
            /> */}

              {/* <Link
                to="/extrato"
                children={
                  <Button
                    color="primary"
                    className="p-2 w-full uppercase rounded-md"
                  >
                    Extrato de pontos
                  </Button>
                }
              /> */}

              {!!hasTeam && !user?.extra.rede && (
                <Link
                  to="/minha-equipe"
                  aria-label="Pendências de aprovação"
                  className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  children={
                    <span className="p-2 w-full uppercase rounded-md relative">
                      Minha Equipe{' '}
                      {!!usersNeedingApproval?.length && (
                        <span className="number-indicator" title="Pendências de aprovação">
                          {usersNeedingApproval?.length}
                        </span>
                      )}
                    </span>
                  }
                />
              )}

              <Link
                to="/rede-joga-junto"
                aria-label="Rede JogaJunto"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                children={<span className="p-2 w-full uppercase rounded-md">Rede JogaJunto</span>}
              />

              {/* {isGestor ? (
              <Link
                to="/minha-equipe/validar-apreciar-realizacao"
                children={
                  <Button
                    color="primary"
                    className="p-2 w-full uppercase rounded-md"
                  >
                    Realização Destaque
                  </Button>
                }
              />
            ) : null}
            {!isGestor ? (
              <Link
                to="/realizacao-destaque"
                children={
                  <Button
                    color="primary"
                    className="p-2 w-full uppercase rounded-md"
                  >
                    Realização Destaque
                  </Button>
                }
              />
            ) : null} */}
              {/*
            <Link
              to="/reconhecer"
              children={
                <Button
                  color="primary"
                  className="p-2 w-full uppercase rounded-md"
                >
                  Emitir Moedas BB
                </Button>
              }
            /> */}

              {/* <Link
              to="/experiencias"
              children={
                <Button color="primary" className="p-2 w-full uppercase rounded-md">
                  Catálogo de experiências
                </Button>
              }
            /> */}

              {user.extra.rede ? (
                <Link
                  to="/regulamento"
                  children={
                    <Button color="primary" className="p-2 w-full uppercase rounded-md">
                      Regras
                    </Button>
                  }
                />
              ) : (
                <a
                  href={rulesUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                  aria-label="Regras do JogaJunto"
                >
                  <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                    Regras
                  </span>
                </a>
              )}

              {/* <Link
                to="/regulamento"
                children={
                  <Button color="primary" className="p-2 w-full uppercase rounded-md">
                    Regras
                  </Button>
                }
              /> */}

              {/* <a
                href="https://banco365.sharepoint.com/sites/NovoJogaJuntoBB"
                target="_blank"
                rel="noreferrer"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                aria-label="Ir para Hotsite do JogaJunto"
              >
                <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                  Hotsite JogaJunto BB
                </span>
              </a> */}

              <Link
                to="/ajuda"
                aria-label="Dúvidas frequentes sobre o JogaJunto"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                children={
                  <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                    dúvidas frequentes
                  </span>
                }
              />

              <Link
                to="/manifesto"
                aria-label="Manifesto do JogaJunto"
                className="bg-purple text-white p-2 w-full text-center uppercase rounded-md hover:ring hover:ring-white hover:text-white hover:no-underline active:text-white active:no-underline shadow-xl font-bold px-4"
                children={
                  <span className="p-2 w-full uppercase rounded-md" aria-hidden="true">
                    Nosso Manifesto
                  </span>
                }
              />

              {!isMSTeams && (
                <Button
                  aria-label="Sair do JogaJunto"
                  onClick={() => {
                    handleLogout();
                    signOut();
                  }}
                  color="outlinePurple"
                  className="p-2 w-full uppercase rounded-md text-white"
                >
                  Sair
                </Button>
              )}

              <div className="text-center text-xs mt-8 text-white text-opacity-90" aria-hidden={'true'}>
                v2.1.034
              </div>
            </div>
          )}
        </div>

        <div className="flex-1 p-6 lg:p-5 2xl:p-10 space-y-5">
          <div
            data-step="1"
            className={`border-electric-blue border-2 bg-oxford-blue rounded-2xl lg:rounded-[20px] flex flex-col lg:flex-row ${
              !sealList ? 'items-center' : ''
            }`}
          >
            <div className="flex flex-col p-8 h-full" tabIndex={0}>
              <div className="lg:flex-none flex flex-row items-center lg:-my-4 lg:p-4 lg:pr-6 space-x-4 lg:space-x-0">
                <div
                  onClick={() => handleAvatarClick()}
                  className="cursor-pointer hover:animate-wiggle flex flex-col items-center justify-center hover:ring-2 ring-white w-16 h-16 lg:w-20 lg:h-20 rounded-full"
                >
                  <UserAvatar data={{ ...user, ...user.extra }} responsive={true} />
                </div>
                <div className="lg:p-3 flex flex-col leading-none">
                  <Humanograma data={{ ...userInfo, _id: userInfo?.chave }}>
                    <div className="flex items-center">
                      <h3
                        className="text-white text-xl lg:text-2xl font-semibold leading-none mr-2"
                        tabIndex={0}
                        aria-label={`${userInfo?.nome_guerra.split(' ')[0]} Chave ${user._id}`}
                      >
                        {userInfo?.nome_guerra.split(' ')[0]}
                      </h3>
                      <span className="text-white font-thin text-xs lg:text-lg leading-none">({user._id})</span>
                    </div>
                  </Humanograma>

                  <div className="-mt-1 mb-1">
                    <p className="text-sm font-light">
                      Função atual: <span className="text-blue-light">{userInfo?.funcao}</span>
                    </p>
                  </div>
                  {/* INÍCIO // VOLTAR QUANDO TIVER NÍVEIS E GRUPOS DOS CICLOS PASSADOS */}
                  {/* {!user.extra.rede && (
                    <div className="flex items-center space-x-2">
                      <p className="text-lg" tabIndex={0} aria-label={`Nível ${getLevelTitle(profile?.nivel)}`}>
                        Nível: <b className="text-blue-light">{getLevelTitle(profile?.nivel)}</b>
                      </p>

                      <Tippy
                        arrow={true}
                        allowHTML={true}
                        className="bg-black text-white font-thin rounded-xl p-2 tippy"
                        content={
                          <div
                            dangerouslySetInnerHTML={{
                              __html: getLevelDescription(profile?.nivel, profile?.grupo),
                            }}
                          />
                        }
                      >
                        <div
                          role="img"
                          tabIndex={0}
                          aria-label={`Mais informações sobre os níveis de engajamento. ${getLevelDescription(profile?.nivel)}`}
                        >
                          <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" aria-hidden="true" />
                        </div>
                      </Tippy>
                    </div>
                  )} */}
                  {/* {!!groupInfo && !!profile && !user?.extra?.rede && (
                    <div
                      className="hidden lg:flex flex-col 2xl:flex-row flex-wrap 2xl:items-center  leading-none space-x-1 text-white text-lg mt-2 cursor-pointerss"
                      onClick={() => null}
                    >
                      <div className="text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-white mb-3 2xl:mb-0">
                        <button
                          aria-label={`Seu grupo é ${profile?.grupo}`}
                          className="bg-none border-none p-0 m-0 cursor-default"
                          tabIndex={0}
                        >
                          GRUPO: {profile?.grupo}
                        </button>
                      </div>
                      <div className="flex items-center space-x-2">
                        <span className="font-thin">({profile?.grupoTotal}</span> funcis)
                      </div>
                    </div>
                  )} */}
                  {/* FIM // VOLTAR QUANDO TIVER NÍVEIS E GRUPOS DOS CICLOS PASSADOS */}
                </div>
              </div>

              {/* INÍCIO // VOLTAR QUANDO TIVER NÍVEIS E GRUPOS DOS CICLOS PASSADOS */}
              {/* {!!groupInfo && !!profile && !user?.extra?.rede && (
                <>
                  <div
                    className="flex w-full lg:hidden flex-col items-center justify-between text-center leading-none space-x-2 text-white text-sm"
                    onClick={() => null}
                  >
                    <div className="text-md p-1 px-4 rounded-2xl bg-maastricht-blue text-electric-blue mb-3 2xl:mb-0">
                      GRUPO: {profile?.grupo}
                    </div>
                    <div className="font-thin flex space-x-2">
                      (<span className="font-light">{profile?.grupoTotal}</span> funcis)
                    </div>
                  </div>

                  <hr className="border-[#072E4A] lg:border-electric-blue w-full my-6 block lg:hidden" />
                </>
              )} */}
              {/* FIM // VOLTAR QUANDO TIVER NÍVEIS E GRUPOS DOS CICLOS PASSADOS */}

              {!!sealList && sealList?.length > 0 ? (
                <div className="flex flex-col lg:block lg:border-t-2 border-[#072E4A] lg:mt-3 lg:pt-3">
                  <h3 className="text-white font-bold text-sm mb-2">Galeria de selos</h3>
                  <div className="flex items-center">
                    {loadingCulturaList && (
                      <div className="grid grid-cols-1 lg:grid-cols-3 items-center lg:gap-8 w-fit rounded-2xl ">
                        <ArticlePlaceholderSmall />
                        <ArticlePlaceholderSmall />
                        <ArticlePlaceholderSmall />
                      </div>
                    )}

                    {sealList && sealList?.length > 0 && (
                      <>
                        <div className="flex items-center">
                          <PointItem
                            data={{
                              items: [...sealList],
                              type: 'destaque_cultura_condensed',
                            }}
                          />
                          <Link
                            to={'/selos'}
                            aria-label="Ir para Galeria de Selos"
                            tabIndex={0}
                            className="text-grey-dark text-xs px-4 py-3 uppercase hover:no-underline hover:text-white active:no-underline"
                          >
                            Ver todos
                          </Link>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <>
                  {!loadingCulturaList && (
                    <div className="hidden lg:block border-t-2 border-[#072E4A] mt-3 pt-3">
                      <h3 className="text-white font-bold text-sm mb-3">Galeria de selos</h3>
                      <div className="flex flex-col text-[#628BA7] text-sm">
                        <b className="text-sm">Sua lista de selos está vazia.</b>
                        <p className="text-sm">
                          Você poderá acumular selos que representam conquistas de desempenho no JogaJunto.
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            {/* {!!groupInfo && (
              <div className="w-full lg:hidden">
                <div className="leading-none flex flex-row items-center justify-between leading-none space-x-1">
                  <div className="text-lg font-bold text-yellow flex-1">{groupInfo.nome}</div>
                  <div className="text-lg p-1 border rounded-lg border-yellow border-opacity-25">{groupInfo.ro}</div>
                  <div className="text-right flex-1">
                    <div className="text-lg leading-none text-yellow">{groupInfo.total}</div>
                    <span>funcis</span>
                  </div>
                </div>
              </div>
            )} */}

            <div className="flex flex-1 flex-col items-center justify-center pt-3 lg:border-l-2 lg:border-electric-blue lg:border-solid">
              <div className="hidden lg:block rounded-lg py-1 px-2 mb-[14px]">
                <button
                  aria-label={`Meus pontos: ${
                    pontosCultura.geral ? Intl.NumberFormat('pt-BR').format(Math.ceil(pontosCultura.geral)) : '0'
                  }`}
                  className="text-white leading-none p-0 mb-4  lg:text-md"
                >
                  <b>Meus Pontos</b>
                </button>
                <div className="bg-maastricht-blue text-center text-blue-light rounded-full py-1 px-2 lg:py-1 lg:px-3 text-2xl lg:text-xl lg:text-3xl font-bold">
                  {pontosCultura.geral ? Intl.NumberFormat('pt-BR').format(Math.ceil(pontosCultura.geral)) : '0'}
                </div>
              </div>
              {/* {!!pontosCultura.time && (
                <p className="font-normal mb-6 text-blue-100 text-[10px]">
                  Atualizado em: {format(utcToZonedTime(pontosCultura.time, 'GMT'), 'dd MMM yyyy')}
                </p>
              )} */}

              <div className="font-bold px-3 py-4">
                <Link
                  to={'/v2/extrato'}
                  aria-label="Ver meu histórico de pontos"
                  className="text-grey-dark text-base lg:text-xs uppercase flex hover:no-underline hover:text-white active:no-underline"
                >
                  <BiPlus color="#C2D2FF" size={14} className="hidden lg:block" />
                  <BiPlus color="#C2D2FF" size={24} className="block lg:hidden" />
                  Ver histórico de pontos
                </Link>
              </div>

              {/* <Tippy
                arrow={false}
                className="hidden lg:block bg-blue-light drop-shadow-lg text-blue-dark"
                allowHTML={true}
                content={getPositionLabel(galeriaReconhecimento)}
              >
                <div className="hidden lg:flex flex-col items-end lg:items-center">
                  <p className="mb-3 text-right lg:text-center leading-none -mt-[15px] uppercase relative">
                    <BiInfoCircle className="mr-1 inline-block lg:hidden" />
                    <b className="lg:text-md block  text-yellow text-center">
                      Galeria do <br />
                      Reconhecimento
                    </b>
                    <BiInfoCircle className="hidden lg:inline-block text-gray-light text-lg absolute -right-6 top-2" />
                  </p>

                  <div className="min-w-[100px] bg-maastricht-blue text-center text-blue-light rounded-full py-1 px-2 lg:py-1 lg:px-3 text-2xl lg:text-xl lg:text-3xl font-bold">
                    {galeriaReconhecimento.position
                      ? `${galeriaReconhecimento.position}º`
                      : '---'}
                  </div>
                </div>
              </Tippy> */}
            </div>

            {/* <div className="flex items-end justify-between lg:hidden w-full">
              <div
                onClick={() => showModal('help-pontos')}
                className="flex items-center justify-end flex-col"
              >
                <p className="text-yellow font-semibold text-xs uppercase leading-none p-0 mb-2 block">
                  Meus Pontos
                </p>
                <div className="bg-maastricht-blue px-4 py-2 text-center text-electric-blue rounded-full font-semibold text-sm">
                  {pontosCultura.geral
                    ? Intl.NumberFormat('pt-BR').format(
                        Math.ceil(pontosCultura.geral)
                      )
                    : '0'}
                </div>
              </div>

              <Tippy
                arrow={false}
                className="bg-blue-light drop-shadow-lg text-blue-dark "
                allowHTML={true}
                content={getPositionLabel(galeriaReconhecimento)}
              >
                <div className="flex items-center justify-end flex-col">
                  <p className="text-yellow font-semibold text-xs uppercase leading-none p-0 mb-2 mr-5 flex items-center justify-center text-center relative">
                    Galeria do <br />
                    Reconhecimento{' '}
                    <BiInfoCircle className="absolute -right-6 top-2 inline-block text-white text-xl" />
                  </p>

                  <div className="bg-maastricht-blue min-w-[60px] px-4 py-2 text-center text-electric-blue rounded-full font-semibold text-sm">
                    {galeriaReconhecimento.position
                      ? `${galeriaReconhecimento.position}º`
                      : '---'}
                  </div>
                </div>
              </Tippy>
            </div> */}
          </div>

          {/* <TutorialChallenges /> */}
          {/* {user.extra.rede && (
            <div
              data-step="2"
              className="border-2 text-lg border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-col sm:flex-row space-y-4"
            >
              <img
                src="https://s3.amazonaws.com/funifier/games/635ae06f8cf58e411eeb0b8e/images/66229d868b31775619ea0284_original_imagem.png"
                alt="Tutorial joga junto rede"
                className="w-full sm:w-[45%] pr-8"
                onClick={() => navigate('/v2/?tutorial=open')}
                style={{ cursor: 'pointer' }}
              />
              <div className="flex flex-col items-center">
                <p>
                  Os reconhecimentos enviados para colegas que fazem a diferença na sua rotina de trabalho podem mudar o dia de
                  cada um deles.
                </p>
                <Button
                  className="uppercase py-2 px-5 rounded w-auto mt-8 text-sm"
                  onClick={() => navigate('/v2/?tutorial=open')}
                  aria-label={`Assistir video de tutorial.`}
                >
                  Assistir vídeo
                </Button>
              </div>
            </div>
          )} */}
          {/* <div
            data-step="2"
            className="border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-col space-y-4"
          >
            <h2 className="text-white font-normal text-xl lg:text-2xl leading-none mb-6 lg:mb-2 text-left" tabIndex={0}>
              Reconheça seus colegas
            </h2>

            <div className="lg:flex  lg:space-x-8">
              <div className="lg:w-2/3 mb-8 lg:mb-0">
                <h3 className="text-white font-thin lg:font-normal text-lg mb-2 lg:mb-5 leading-none" tabIndex={0}>
                  Saldo total para enviar reconhecimentos:{' '}
                  <span className="text-yellow">
                    {user?.point_categories?.point_behavior || 0} ponto
                    {!isNaN(user?.point_categories?.point_behavior) && user?.point_categories?.point_behavior !== 1 ? 's' : ''}
                  </span>
                </h3>

                {currentCycle?.status === 'open' ? (
                  <p className="block lg:hidden mb-6 text-xs font-thin text-white">
                    Seu saldo atual expira em:{' '}
                    <strong className="font-bold">
                      <Countdown deadline={new Date(currentCycle.date_finish)} />
                    </strong>
                  </p>
                ) : null}

                <div
                  data-step="3"
                  className="flex lg:grid lg:grid-cols-3 lg:grid-rows-1 lg:gap-6 flex-col items-center space-y-4 lg:space-y-0 text-center text-yellow font-bold rounded-lg lg:hover:ring-2 lg:hover:ring-white hover:cursor-pointer"
                  onClick={() => showModal('help-moedas-bb')}
                >
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto bg-none border-none"
                    aria-label="Reconhecimento #UAU equivale a 300 ponto"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin flex-1">
                        <Uau size={20} />
                      </div>
                      <p className="font-normal text-xs leading-tight text-white">#UAU</p>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      300 pontos
                    </p>
                  </button>
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto  bg-none border-none"
                    aria-label="Reconhecimento #MANDOUBEM equivale a 200 pontos"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin mandou flex-1">
                        <MandouBem size={20} />
                      </div>
                      <div className="font-normal text-xs leading-tight text-white">#MANDOUBEM</div>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      200 pontos
                    </p>
                  </button>
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto bg-none border-none"
                    aria-label="Reconhecimento #VALEU equivale a 100 pontos"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin flex-1">
                        <Valeu size={20} />
                      </div>
                      <p className="font-normal text-xs leading-tight text-white">#VALEU</p>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      100 pontos
                    </p>
                  </button>
                </div>

                {currentCycle?.status === 'open' ? (
                  <p className="hidden lg:block mt-3 text-sm font-thin text-white" tabIndex={0}>
                    Seu saldo atual expira em:{' '}
                    <strong className="font-bold">
                      <Countdown deadline={new Date(currentCycle.date_finish)} />
                    </strong>
                  </p>
                ) : null}
              </div>

              {currentCycle?.status === 'open' ? (
                <div className="flex-1 flex flex-col text-center items-center">
                  {!isNaN(user?.point_categories?.point_behavior) && user?.point_categories?.point_behavior >= 100 ? (
                    <>
                      <p className="text-sm font-light text-white mb-4" tabIndex={0}>
                        Viu alguém que fez a diferença no seu trabalho? <br className="hidden lg:block" />
                        Deixe-o ficar sabendo disso!
                      </p>
                      <Button
                        className="uppercase py-2 px-5 rounded w-auto"
                        onClick={() => navigate('/reconhecer')}
                        aria-label={`Reconhecer colega. Abre modal para registrar o reconhecimento.`}
                      >
                        Reconhecer colega
                      </Button>
                      <div className="font-bold px-3 py-4">
                        <Link
                          to={'/v2/extrato?active=1&sub=SENDED'}
                          className="text-grey-dark text-base lg:text-xs uppercase flex hover:no-underline hover:text-white active:no-underline"
                        >
                          <BiPlus color="#C2D2FF" size={14} className="hidden lg:block" />
                          <BiPlus color="#C2D2FF" size={24} className="block lg:hidden" />
                          ver reconhecimentos
                        </Link>
                      </div>
                    </>
                  ) : (
                    <>
                      <div tabIndex={0}>
                        <p className="text-sm font-light text-white mb-1">Você não possui saldo de pontos para reconhecer.</p>
                        <p className="text-sm font-light text-white">Aguarde até a próxima distribuição.</p>
                      </div>
                    </>
                  )}
                </div>
              ) : null}
            </div>
          </div> */}

          {/* <div
            data-step="4"
            className="border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-row items-center justify-between"
          >
            <div className="w-full">
              <div className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 lg:mb-4 text-left">
                Dimensões do Comportamento
              </div>

              <p className="font-light mb-8 lg:mb-0 text-left block">
                Meus pontos recebidos em cada comportamento e minha posição
                dentro dos{' '}
                <span className="text-yellow">Destaques da Cultura</span>
              </p>

              <div className="grid grid-cols-2 gap-8 lg:flex lg:flex-row items-start lg:items-center justify-between lg:mt-5 lg:px-10">
                <div
                  className={`${
                    !pontosCultura.colaboracao || pontosCultura.colaboracao <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(
                      destaqueCultura.colaboracao
                    )}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.colaboracao.posicao
                        ? `${destaqueCultura.colaboracao.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() =>
                      showModal('comportamento-help', 'colaboracao')
                    }
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <Colaboracao size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    COLABORAÇÃO
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.colaboracao}</b>pts
                    </span>
                  </div>
                </div>

                <div
                  className={`${
                    !pontosCultura.inovacao || pontosCultura.inovacao <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(destaqueCultura.inovacao)}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.inovacao.posicao
                        ? `${destaqueCultura.inovacao.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() => showModal('comportamento-help', 'inovacao')}
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <Inovacao size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    INOVAÇÃO
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.inovacao}</b>pts
                    </span>
                  </div>
                </div>

                <div
                  className={`${
                    !pontosCultura.foco || pontosCultura.foco <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(destaqueCultura.foco)}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.foco.posicao
                        ? `${destaqueCultura.foco.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() => showModal('comportamento-help', 'foco')}
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <FocoNoCliente size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    FOCO NO CLIENTE
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.foco}</b>pts
                    </span>
                  </div>
                </div>

                <div
                  className={`${
                    !pontosCultura.resolutividade ||
                    pontosCultura.resolutividade <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(
                      destaqueCultura.resolutividade
                    )}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.resolutividade.posicao
                        ? `${destaqueCultura.resolutividade.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() =>
                      showModal('comportamento-help', 'resolutividade')
                    }
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <Resolutividade size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    PROTAGONISMO
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.resolutividade}</b>pts
                    </span>
                  </div>
                </div>

                <div
                  className={`${
                    !pontosCultura.lideranca || pontosCultura.lideranca <= 0
                      ? 'opacity-60'
                      : ''
                  } text-center flex flex-col items-center`}
                >
                  <Tippy
                    arrow={false}
                    className="bg-blue-light drop-shadow-lg text-blue-dark"
                    allowHTML={true}
                    content={getPositionCulturaLabel(destaqueCultura.lideranca)}
                  >
                    <b className="text-sm lg:text-2xl font-normal lg:font-semibold mb-2 lg:mb-0 relative">
                      {destaqueCultura.lideranca.posicao
                        ? `${destaqueCultura.lideranca.posicao}º`
                        : '---'}
                      <BiInfoCircle className="bottom-0 -right-5 absolute text-yellow text-lg inline-block" />
                    </b>
                  </Tippy>
                  <div
                    onClick={() => showModal('comportamento-help', 'lideranca')}
                    className="hover:ring-4 cursor-pointer w-14 lg:w-20 h-14 lg:h-20 overflow-hidden bg-blue-light bg-opacity-10 ring-1 ring-yellow rounded-full mb-3 lg:mb-2"
                  >
                    <Lideranca size={'100%'} />
                  </div>
                  <b className="text-xs lg:text-md font-thin lg:font-normal mb-3 lg:mb-0 mt-0 lg:mt-2">
                    LIDERANÇA ENGAJADORA
                  </b>
                  <div className="bg-maastricht-blue text-white p-3 rounded-lg mt-0 lg:mt-3">
                    <span className="font-thin">
                      <b className="mr-1">{pontosCultura.lideranca}</b>pts
                    </span>
                  </div>
                </div>
              </div>
              <div className="hidden lg:block text-center text-white pt-4 px-4">
                Pontuação e classificação visível somente a você.
              </div>
            </div>
          </div> */}
          <div
            data-step="2"
            className="relative border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-col space-y-4"
          >
            <h2 className="text-white font-normal text-xl lg:text-2xl leading-none mb-6 lg:mb-2 text-left" tabIndex={0}>
              Reconheça seus colegas
            </h2>

            <div className="lg:flex  lg:space-x-8">
              <div className="lg:w-2/3 mb-8 lg:mb-0">
                <div
                  data-step="3"
                  className="flex lg:grid lg:grid-cols-3 lg:grid-rows-1 lg:gap-6 flex-col items-center space-y-4 lg:space-y-0 text-center text-yellow font-bold rounded-lg lg:hover:ring-2 lg:hover:ring-white hover:cursor-pointer"
                  onClick={() => showModal('help-moedas-bb')}
                >
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto bg-none border-none"
                    aria-label="Reconhecimento #UAU equivale a 300 ponto"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin flex-1">
                        <Uau size={20} />
                      </div>
                      <p className="font-normal text-xs leading-tight text-white">#UAU</p>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      300 pontos
                    </p>
                  </button>
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto  bg-none border-none"
                    aria-label="Reconhecimento #MANDOUBEM equivale a 200 pontos"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin mandou flex-1">
                        <MandouBem size={20} />
                      </div>
                      <div className="font-normal text-xs leading-tight text-white">#MANDOUBEM</div>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      200 pontos
                    </p>
                  </button>
                  <button
                    className="box-coins-home relative bg-maastricht-blue rounded-lg p-4 flex flex-col justify-center items-center w-[165px] lg:w-auto bg-none border-none"
                    aria-label="Reconhecimento #VALEU equivale a 100 pontos"
                    tabIndex={0}
                  >
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="coin flex-1">
                        <Valeu size={20} />
                      </div>
                      <p className="font-normal text-xs leading-tight text-white">#VALEU</p>
                    </div>
                    <p className="text-electric-blue text-xs font-light leading-none bg-prussian-blue py-1 px-3 rounded-full">
                      100 pontos
                    </p>
                  </button>
                </div>
              </div>

              <div className="flex-1 flex flex-col text-center items-center">
                <>
                  <div tabIndex={0}>
                    <p className="text-sm font-light text-white mb-1">Esse ciclo já foi encerrado.</p>
                  </div>

                  <div className="font-bold px-3 text-center py-4">
                    <Link
                      to={'/v2/extrato?active=1&sub=SENDED'}
                      className="text-grey-dark text-center text-base lg:text-xs uppercase flex hover:no-underline hover:text-white active:no-underline"
                    >
                      <BiPlus color="#C2D2FF" size={14} className="hidden lg:block" />
                      <BiPlus color="#C2D2FF" size={24} className="block lg:hidden" />
                      ver reconhecimentos
                    </Link>
                  </div>
                </>
              </div>
            </div>
          </div>

          {!user.extra.rede && (
            <>
              <div
                data-step="5"
                className="border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-row items-center justify-between"
              >
                <div className="w-full">
                  <TaskCycles />
                </div>
              </div>
            </>
          )}

          {cycleSelected?.title !== '1S2023' && (
            <div
              data-step="5"
              className="border-2 border-electric-blue bg-oxford-blue rounded-2xl lg:rounded-[20px] px-6 lg:px-8 py-8 flex flex-row items-center justify-between"
            >
              <div className="w-full">
                <h2 className="text-white font-normal text-xl lg:text-2xl leading-none mb-4 text-left" tabIndex={0}>
                  Ações de Engajamento
                </h2>
                <Company />
              </div>
            </div>
          )}
        </div>
      </div>
      {showTutorial && closeFeatures && (
        <UserTutorial
          open={openTutorial}
          onClose={() => {
            setOpenTutorial(false);
            setShowTutorial(false);
          }}
        />
      )}
      {userInfo && <NewFeatures player={userInfo} send={() => setCloseFeatures(true)} />}
      <ComportamentoHelpModal />
      {/* <SeloHelpModal /> */}
      {/* <Decoration /> */}
      {/* <GameModal /> */}
      <SeloMoedasModal />
      {/* <PontosHelpModal /> */}
      <GroupDetailModal group={groupInfo} />
      <Notification />
      {showQuiz && <Quiz onClose={() => setShowQuiz(false)} setQuizAnswered={() => {}} />}
      {/* <UserNeedingApprovalModal users={usersNeedingApproval} /> */}
      {/* <GroupDetailModal totalGroup={groupInfo?.total} /> */}
    </>
  );
}
